import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  wrapper: {
    height: '100vh',
  },
});

export default useStyles;
